/**
 * Avalara © 2017
 * file: engines/opus_ui/config/index.js
 */

var env = process.env.REACT_APP_ENV || 'development';
const config = require('./app-config-' + env + '.json');
module.exports = config;
